import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import poActions from '../actions/purchaseOrder';

function recordApproval(store, action) {
    const {commercialOfferType, advertiserBusinessModel, accountUuid, isPMISBusinessModelSwitchFlow} = action.payload;

    return request.post(`/${config.url_prefix}/api/recordApproval`)
        .send({
            data: commercialOfferType,
            accountUuid,
            isPMISBusinessModelSwitchFlow
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, res) => {
            if (error || !res || res.statusCode > 400 || res.code > 400) {
                store.dispatch(poActions.recordApprovalError('ipmob.internal.server.error'));
                store.dispatch(actions.enableLoadOverLay(false));
            } else if (advertiserBusinessModel === 'EG') {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(actions.changeAppState('COMPLETE_PAGE'));
            }
            else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(actions.changeAppState('BILLING_INFORMATION'));
            }
        });
}

export default recordApproval;
